<template>
  <div class="row">
    <!-- main title -->
    <div class="col-12">
      <div class="main__title">
        <h2>نظرات افراد</h2>
      </div>
    </div>
    <!-- end main title -->

    <!-- form -->
    <div class="col-12">

      <div class="row">
        <!-- main title -->
        <!-- end main title -->
<div v-if="reply_dialog">
  <div class="form__group">
    <textarea v-model="reply_text"
              name="text" class="form__textarea"
              placeholder="پاسخ به نظر">

    </textarea>
  </div>
  <button class="sign__btn" @click="send_reply_comment()" type="button">ثبت پاسخ</button>
</div>
        <!-- users -->
        <div class="col-12">
          <Datatable
              :items="items.filter(x=>x.source==null)"
              :fields="fields"
              style="overflow: auto"
              :items-per-page="20"
              hover
              height="300px"
              border
              striped
              sorter
              column-filter
              pagination
          >
            <template #row="{item,index}">
              <td>
                <div class="main__table-text">{{ index + 1 }}</div>
              </td>
            </template>
            <template #poster="{item,index}">
              <td>
                <div class="main__table-text">{{ item.post.post_title }}</div>
              </td>
            </template>
            <template #comment_summary="{item,index}">
              <td>
                <div class="main__table-text">
                  <div class="form__group">
                    <textarea v-model="item.comment_summary" type="text" class="form__input"></textarea>
                  </div>
                </div>
                <div class="main__table-text" v-if="items.filter(x=>x.source==item.id).length>0">
                  <div class="form__group">
                    پاسخ:
                    {{items.filter(x=>x.source==item.id)[0].comment_summary}}
                  </div>
                </div>

              </td>
            </template>
            <template #operation="{item}">
              <td>
                <div class="main__table-btns">

                  <div v-if="item.status==0" @click="change_comment_status(1,item)" datas="#"
                       class="button-table">

                    تایید کردن
                  </div>
                  <div v-if="item.status==1" @click="change_comment_status(0,item)" datas="#"
                       class="button-table">

                    عدم تایید
                  </div>
                  <div  @click="edit_comment(0,item)" datas="#"
                       class="button-table">

                    ویرایش
                  </div>
                  <div
                      @click="reply_comment(item)"
                      class="button-table">

                    پاسخ دادن
                  </div>

                </div>
              </td>
            </template>
          </Datatable>

        </div>


      </div>
    </div>
    <!-- end form -->
  </div>
</template>

<script>
import axios from "axios";
// import {bus} from '../main';
import Datatable from "@/views/customTable/Datatable";
import SeoProgress from "@/views/CustomComponent/SeoProgress.vue";

export default {
  name: 'HelloWorld',
  data() {
    return {
      items: [],
      fields: [
        {key: 'row', label: 'ردیف' ,_style:"width:3%"},
        {key: 'poster', label: 'بلاگ'},
        {key: 'comment_summary', label: 'پیام'},
        {key: 'operation', label: 'عملیات'}
      ],
      status_form: 0,
      name: '',
      reply_text: '',
      reply_dialog:false,
    }
  },
  components: {
    Datatable
  },
  mounted() {
    this.get_data();
  },
  methods: {
    reply_comment(item) {
      this.reply_dialog = true;
      this.status_form = item.id;

    },
    get_data() {

      var self = this;

      var formData = new FormData();

      this.axios.post('get_blog_comments', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.items = content_data

      }).catch(function (error) {
        console.log(error);
      });


    },
    change_comment_status(status, item) {

      var self = this;

      var formData = new FormData();
      var url = 'confirm_blog_comment'
      formData.append('id', item.id);
      formData.append('status', status);

      this.axios.post(url, formData, {}).then(function (response) {

        self.get_data()
        self.$toast.success('ثبت با موفقیت انجام شد');

      }).catch(function (error) {
        console.log(error);
        self.$toast.error('خطا در ثبت اطلاعات');

      });


    },
    edit_comment(status, item) {

      var self = this;

      var formData = new FormData();
      var url = 'edit_blog_comment'
      formData.append('id', item.id);
      formData.append('message', item.comment_summary);

      this.axios.post(url, formData, {}).then(function (response) {

        self.get_data()
        self.$toast.success('ثبت با موفقیت انجام شد');

      }).catch(function (error) {
        console.log(error);
        self.$toast.error('خطا در ثبت اطلاعات');

      });


    },
    send_reply_comment(status, item) {

      var self = this;

      var formData = new FormData();
      var url = 'reply_blog_comment'
      formData.append('id', this.status_form);
      formData.append('text', this.reply_text);
      // formData.append('token',localStorage.getItem("token"));

      this.axios.post(url, formData, {
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("login_info")
        }
      }).then(function (response) {

        self.get_data()
        self.$toast.success('ثبت با موفقیت انجام شد');

      }).catch(function (error) {
        console.log(error);
        self.$toast.error('خطا در ثبت اطلاعات');

      });


    },
  }
}
</script>

